var Dev = /** @class */ (function () {
    function Dev() {
        var _this = this;
        this._ctrl_pressed = false;
        this._dev_element = document.querySelector('.c-dev');
        if (this._dev_element) {
            var toggle_element = this._dev_element.querySelector('.c-dev__toggle');
            toggle_element === null || toggle_element === void 0 ? void 0 : toggle_element.addEventListener('click', function () { return _this.handleToggleClicked(); });
            // this.handleToggleClicked();
            document.addEventListener("keydown", function (event) {
                if (event.key === "Control")
                    _this._ctrl_pressed = true;
            });
            document.addEventListener("keyup", function (event) {
                if (event.key === "Control")
                    _this._ctrl_pressed = false;
                if (event.key === 'l' && _this._ctrl_pressed)
                    _this.handleToggleClicked();
            });
        }
    }
    Dev.prototype.handleToggleClicked = function () {
        var _a;
        (_a = this._dev_element) === null || _a === void 0 ? void 0 : _a.classList.toggle('s-active');
    };
    return Dev;
}());
new Dev();
